export default __webpack_public_path__ + "static/media/content-background-2.78db3f43.svg";